import React from "react";
import WrapperModule from "../WrapperModule";
import { Routes, Route } from "react-router-dom";
export function LazyLoadModules(props) {
    var _a, _b;
    return (React.createElement(React.Fragment, null,
        React.createElement(Routes, null,
            React.createElement(Route, { path: "*", element: React.createElement(WrapperModule, { siteConfig: props === null || props === void 0 ? void 0 : props.siteConfig, pagedata: (_a = props === null || props === void 0 ? void 0 : props.pageData) === null || _a === void 0 ? void 0 : _a.modules, moduleCount: (_b = props === null || props === void 0 ? void 0 : props.pageData) === null || _b === void 0 ? void 0 : _b.moduleCount, pathName: props === null || props === void 0 ? void 0 : props.pathName }) }))));
}
